<template>
  <div class="steps">
    <el-steps
      class="fe-step"
      :active="status"
      :space="218"
      align-center
      finish-status="success"
      process-status="process"
    >
      <el-step title="上传照片"></el-step>
      <el-step title="后台审核"></el-step>
      <el-step title="工卡制作"></el-step>
    </el-steps>
  </div>
</template>

<script>
/* 步骤条组件
status: 步骤条状态 */
export default {
  props: {
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.steps {
  .fe-step /deep/ {
    margin-left: 140px;
    .el-step__icon {
      width: 28px;
      height: 28px;
      background-color: rgba(66, 114, 171, 1);
      border-radius: 50%;
      font-size: 16px;
      color: #ffffff;
      box-sizing: border-box;
      border-width: 0;
      border-color: #ffffff;
    }
    .el-step__title {
      font-weight: normal;
      color: #333333;
      font-size: 14px;
      line-height: 20px;
      margin-top: 10px;
      margin-bottom: 27px;
    }

    .el-step__line {
      top: 16px;
      background: #ebebeb;
    }

    .is-success {
      .el-step__line {
        height: 2px;
        border: none;
        background-color: #1989fa;
      }
      .el-step__line-inner {
        display: none;
      }
    }

    .is-wait {
      .el-step__icon {
        background: transparent;
      }
      .el-step__icon-inner {
        color: transparent;
        width: 10px;
        height: 10px;
        background-color: rgba(66, 114, 171, 1);
        font-size: 0;
        border-radius: 10px;
      }
      &.el-step__title {
        color: #999999;
      }
    }

    .is-process {
      .el-step__icon-inner {
        color: transparent;
        width: 10px;
        height: 10px;
        background-color: #ffffff;
        border-radius: 10px;
        font-size: 0;
      }
    }
  }
}
</style>
